import React, { PureComponent } from 'react';
import * as PropTypes from 'prop-types';
import {
    lastThSpanStyles,
    middleThStyles,
    tableHeadStyles,
    thSpanStyles
} from '../../styles/PermissionsTable.css';
import PermissionGroup from './PermissionGroup';

const PermissionRows = props => {
    const { permissions, disabled, showSubRows } = props;
    const groupMap = {};
    permissions.forEach(permission => {
        if (groupMap[permission.group] == null) {
            groupMap[permission.group] = {
                name: permission.group,
                permissions: []
            };
        }
        groupMap[permission.group].permissions.push(permission);
    });
    // would use Array.from(map.values()) instead of Object.keys().sort(),
    // but IE11 has to ruin the fun by not supporting Map.values()...
    const permissionGroups = Object
        .keys(groupMap)
        .sort((a, b) => a.localeCompare(b))
        .map(groupName => (
            <PermissionGroup
                permissionGroup={groupMap[groupName]}
                key={groupName}
                disabled={disabled}
                showSubRows={showSubRows}
            />
        ));
    return <React.Fragment>{permissionGroups}</React.Fragment>;
};

class PermissionsTable extends PureComponent {
    getHeaders = () => {
        let headers = [];
        headers.push(<th key={1} />);
        headers.push(
            <th key={2} style={middleThStyles}>
                <span style={thSpanStyles}>Access</span>
            </th>
        );
        headers.push(
            <th key={3} style={middleThStyles}>
                <span style={lastThSpanStyles}>Scope</span>
            </th>
        );

        return headers;
    };

    render() {
        const headers = this.getHeaders();
        return (
            <div className="col-9">
                <table className="table">
                    <thead style={tableHeadStyles}>
                    <tr>{headers}</tr>
                    </thead>
                    <tbody>
                    <PermissionRows
                        permissions={this.props.permissions}
                        disabled={this.props.disabled}
                        showSubRows={this.props.showSubRows}
                    />
                    </tbody>
                </table>
            </div>
        );
    }
}

PermissionsTable.propTypes = {
    //Permissions array received from the /permissions API call
    //Not the same as the permissions to include in security group
    permissions: PropTypes.array.isRequired,
    disabled: PropTypes.bool,
    showSubRows: PropTypes.bool
};

export default PermissionsTable;
